import $$ from 'cmn-utils'

const baseUrl = "/api/temp/snapshot/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
}